import * as React from "react";
import { forwardRef } from "react";
const SvgAccept = (props, ref) => /* @__PURE__ */ React.createElement("svg", { width: 13, height: 10, viewBox: "0 0 13 10", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M4.43429 9.89504L0.151001 5.61176L1.37455 4.38821L4.43559 7.44578L4.43429 7.44708L11.7765 0.104919L13 1.32847L5.65784 8.6715L4.43515 9.89418L4.43429 9.89504Z", fill: "#056FFF" }));
const ForwardRef = forwardRef(SvgAccept);
export default ForwardRef;
